<template>

    <v-app-bar>

        <div class="d-flex align-center">



            <!-- Logo -->
            <div>
                <img src="@assets/images/header/logo-nlb-buy&go.svg" alt="NLB Buy&Go logo" class="logo">
            </div>

        </div>

        <div class="d-flex ga-4 align-center">

            <!-- Navigation links -->
            <v-list v-if="appStore.User.CanAccessPortal" :disabled="appStore.User.NeedsToChangePassword"
                class="app-bar__links d-none d-lg-flex">

                <!-- Uporabniški center / informacije -->
                <v-list-item rounded title="Informacije" :to="{ name: 'info_home' }"
                    :prepend-icon="route.matched.some(x => x.name == 'info_home') ? 'custom:iconAppBarInformacijeActive' : 'custom:iconAppBarInformacijeInactive'">
                </v-list-item>

                <!-- Uporabniški center / informacije -->
                <v-list-item rounded title="Izobraževanja" :to="{ name: 'training_home' }"
                    :prepend-icon="route.matched.some(x => x.name == 'training_home') ? 'custom:iconAppBarCertificateActive' : 'custom:iconAppBarCertificateInactive'">
                </v-list-item>

                <!-- Uporabniški center / informacije -->
                <v-list-item rounded title="Kontakt" :to="{ name: 'contact_home' }"
                    :prepend-icon="route.matched.some(x => x.name == 'contact_home') ? 'custom:iconAppBarContactActive' : 'custom:iconAppBarContactInactive'">
                </v-list-item>

            </v-list>

            <!-- User menu -->
            <v-menu>

                <template v-slot:activator="{ props }">
                    <div v-bind="props">

                        <!-- User name -->
                        <v-btn class="btn btn--primary-fill d-none d-lg-flex">
                            {{appStore.User.FullName.split(' ').map(name =>
                                name.charAt(0).toUpperCase() +
                                name.slice(1).toLowerCase()).join(' ')}}
                        </v-btn>

                    </div>
                </template>

                <v-list>
                    <v-list-item v-for="(item, i) in navBtns" :key="i" :title="item.title"
                        :active="$router.currentRoute.value.matched.some(route => route.name == item.routerName) && $router.currentRoute.value.params.flowType != 'vloga'"
                        @click="item.runFunction ? item.runFunction() : changeRoute(item.routerName)">
                    </v-list-item>

                </v-list>

            </v-menu>

            <!-- Navigation icon -->
            <v-app-bar-nav-icon class="d-flex d-lg-none"
                @click.stop="appStore.ShowNavDrawer.ShowDrawerLeft = !appStore.ShowNavDrawer.ShowDrawerLeft">
            </v-app-bar-nav-icon>

        </div>

    </v-app-bar>
</template>

<script setup lang="ts">
    import { useAppStore } from "@appstore/store";
    import router from "@app/router";
    import { useFw4Store, MessageBoxPredefinedButtons, MessageBoxButtonType } from "fw4-library";
    import { useContractCreateStore } from "@/app/store/app/contract-create-store";
    import { commClient } from "fw4-library";
    import { useRoute } from "vue-router";

    let appStore = useAppStore();
    const fw4 = useFw4Store();
    const route = useRoute();

    const contractCreateStore = useContractCreateStore();

    let navBtns = contractCreateStore.AppState.AppNavButtons = [
        {
            title: "Urejanje profila",
            routerName: "profil_home",
        },
        {
            title: "Izhod",
            routerName: "",
            runFunction: () => {
                LogOut()
            },
        }
    ];

    function changeRoute(route: string) {
        if (route == "nastavitev_stranka" && router.currentRoute.value.params.flowType == "vloga") {
            fw4.ShowMessageBox("Preklic oddaje vloge", "Ste prepričani, da želite preklicati postopek oddaje vloge za odobritev limita vnaprej?", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel],
                MessageBoxPredefinedButtons[MessageBoxButtonType.OK]
            ]).then((buttonId: any) => {
                if (buttonId == "OK") {
                    router.push({ name: route });
                }
            })
        }
        else {
            router.push({ name: route });
        }
    };

    //Logout
    function logOutAccept() {
        if (commClient.WebSocketConnected) {
            commClient.disconnectWebSockets();
        }
        //resetaj store
        contractCreateStore.reset();
        router.push({ name: "home" });
    };

    function LogOut() {
        fw4.ShowMessageBox("Odjava iz aplikacije", "Ste prepričani, da želite zapustiti aplikacijo?", [
            MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel],
            MessageBoxPredefinedButtons[MessageBoxButtonType.OK]
        ]).then((buttonId: any) => {
            if (buttonId == "OK") {
                logOutAccept();
            }
        })
    };
</script>